class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      } 
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    const searchLimit = this.input.dataset.limit;
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm,searchLimit);
  }
  getSearchResults(searchTerm,searchLimit) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[limit]=${searchLimit}&resources[options][fields]=vendor,product_type,tag,body`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }           
      if(document.getElementById('SearchValueMobile')){
        document.getElementById('SearchValueMobile').value = searchTerm;
      }           
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    // show the results/error state and hide the empty (suggestions + trending) state
    document.body.classList.add('search-has-query');
  }
  close() {
    // back to the empty (suggestions + trending) state
    document.body.classList.remove('search-has-query');
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
  menuBurger.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-menu');
    document.querySelector('body').classList.remove('open-drawer','open-search','open-sort','open-filter');    
  });
});
document.querySelectorAll('.mobile-search').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter');
    document.querySelector(".mobile-serachbox #Search").focus();
  });
});
// document.querySelector('.overlay-box').addEventListener('click',function(e){
//   document.querySelector('body').classList.remove('open-menu');
// });
if(document.querySelectorAll('.variant-grid')){
  function quickAddButton(){
    document.querySelectorAll('.variant-grid').forEach(function(sizeList){
      sizeList.addEventListener('click',function(e){
        e.preventDefault();
        let variant_id = sizeList.dataset.id;
        let error_grid_outer = sizeList.closest('.snippet-product-grid');
        let error_grid = error_grid_outer.querySelector('.grid-error');
        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((data) => {
          
          if(data.status == 422)
          {
            error_grid.innerHTML = data.description;
            setTimeout(function(e){
              error_grid.innerHTML = '';
            },2000);
          }else{          
            if(document.location.href.indexOf('/cart') > -1) {
              window.location.href = "/cart";
            }else{
              if(typeof load_cart == 'function'){
                console.log('data',data.items);
                
                if(data.items.length > 0 && data.items[0].final_price != undefined){
                  var isGiftCard = data.gift_card;
                  var option_price = Shopify.formatMoney(data.items[0].final_price); 
                  data.items[0].options_with_values.forEach(function (option) {
                    if(option.name == "Color") {
                      option_color = option.value;
                    }
                    if(option.name == "Size") {
                      option_size = option.value; 
                    }
                  });
                  // var pro_title = data.items[0].product_title.split("|")[0].split("-")[0];
                   var pro_title = data.items[0].product_title.split("|")[0];
                  document.querySelector("#cart-notification-product").innerHTML = "";        
                  document.querySelector("#cart-notification-product").innerHTML = 
                  `<div class="main_notification row">
                    <div class="lef_notification">
                      <img src="${data.items[0].featured_image.url}" alt="${data.items[0].featured_image.alt}">
                    </div>
                    <div class="center_notification">
                      <div>
                      <p>${pro_title}</p>
                      <div class="pro_var mt-6">
                        <div class="singal_var">${isGiftCard ? '' : option_size + '/' + option_color}</div>
                      </div>
                    </div>
                    <div class="right_notification">
                      <div class="cart-price">${option_price}</div>
                    </div>
                  </div>`;
                }
                
                load_cart();
                setTimeout(() => {
                  $('.main_cart_notification').addClass('active');
                }, "1500")
                setTimeout(() => {
                  $('.main_cart_notification.active').removeClass('active');
                }, "5000")
                setTimeout(function(e){
                  // document.querySelector('body').classList.add('open-drawer');
                },500);
              }else{
                window.location.href = "/cart";
              }          
            }
            const url = '/cart.js';
            fetch(url)
            .then((resp) => resp.json())
            .then(function(data) {
              var cart_count = data.item_count;
              if(cart_count>0){
      	document.querySelectorAll('.header-cart.none_991 .cart-count').forEach( c_count =>{
          c_count.innerHTML = '(' + cart_count + ')';
        })
      	document.querySelectorAll('.header-cart.block_991 .cart-count').forEach( c_count =>{
          c_count.innerHTML = cart_count;
        })
        document.querySelector('.header-cart.block_991 .cart-count').classList.add('active');
      }else{
      	document.querySelectorAll('.header-cart.none_991 .cart-count').forEach( c_count => {
          c_count.innerHTML = '(0)';
        })
      	document.querySelectorAll('.header-cart.block_991 .cart-count').forEach( c_count => {
          c_count.innerHTML = 0;
        })
        document.querySelector('.header-cart.block_991 .cart-count').classList.remove('active');
      }
            })
            .catch(function(error) {
              console.log(error);
            })
          }
        })
        .catch((error) => {
          console.error(error);
        });
      });
    });    
//     document.querySelectorAll('.quick-add').forEach(function(quickAdd){
//       quickAdd.onclick = function(){
//         document.querySelectorAll('.snippet-product-grid').forEach(function(everyProduct){       
//           everyProduct.classList.remove('active-quick');
//         });
//         let gridimgbox = quickAdd.closest('.snippet-product-grid');      
//         gridimgbox.classList.add('active-quick');
//       };
//     });
  }
  quickAddButton();
}
// if(document.querySelector('.mobile-nav .nav-wrap')){
//   document.querySelectorAll('.mobile-nav .nav-wrap a').forEach(function(navArrow){
//     navArrow.addEventListener('click',function(e){
//       navArrow.closest('li').classList.toggle('active');
//       document.querySelector('.snippet-menu-drawer').scrollTop = 0
//     });
//   });
// }

const navItems = document.querySelectorAll(".mobile-nav .nav-wrap");
navItems.forEach((navWrap) => {
  navWrap.addEventListener("click", function (e) {
    e.preventDefault();
    const currentDropdown = this.parentElement.querySelector(".navmobile-dropdown");

    // Close all dropdowns
    document.querySelectorAll(".navmobile-dropdown").forEach(dropdown => {
      if (dropdown !== currentDropdown) {
        dropdown.style.maxHeight = null;
        dropdown.classList.remove("open");
      }
    });

    // Toggle current
    if (currentDropdown.classList.contains("open")) {
      currentDropdown.style.maxHeight = null;
      currentDropdown.classList.remove("open");
    } else {
      currentDropdown.classList.add("open");
      currentDropdown.style.maxHeight = currentDropdown.scrollHeight + "px";
    }
  });
});

if(document.querySelector('.list-menu')){
  document.querySelectorAll('.list-menu > li').forEach(function(navList){
    navList.addEventListener('mouseover', function(){
      navList.classList.add('active');
    });
    navList.addEventListener('mouseout', function(){
      navList.classList.remove('active');
    });
  });
}
document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-search');
  }
};
if (__st.p === 'home'){
  gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
  ScrollSmoother.create({
    wrapper: "#smooth-wrapper",
    content: "#MainContent",
    smooth: 1.5,
    effects: true
  });
}
if (__st.p === 'home' && window.matchMedia('(min-width:992px)').matches) {
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.create({
    trigger: '.section-media-section',
    start: 'top bottom',
    once: true,
    onEnter: () => {
      document.querySelectorAll('.media-section a').forEach((wrapper) => {
        let fromY = '0%';
        let toY = '15%';
        let triggerStart = 'top bottom';

        gsap.fromTo(
          wrapper,
          { y: fromY },
          {
            y: toY,
            ease: 'none',
            scrollTrigger: {
              trigger: wrapper,
              start: triggerStart,
              end: 'bottom top',
              scrub: true
            }
          }
        );
      });
    }
  });
}


// function attachYotpoButtonRedirect() {
//   const buttons = document.querySelectorAll(".yotpo-widgets-action-button");

//   if (!buttons || buttons.length === 0) {
//     setTimeout(attachYotpoButtonRedirect, 200);
//     return;
//   }

//   buttons.forEach((button) => {
//     // Skip if already attached
//     if (button.dataset.redirectAttached) return;

//     const label = button.querySelector(".yotpo-button-label")?.textContent.trim();

//     if (label === "START YOUR JOURNEY") {
//       button.addEventListener("click", function(e) {
//         e.preventDefault();
//         let url = window.location.origin + "/account/register?return_url=/pages/rewards";
//         window.location.href = url;
//       });
//     } else if (label === "LOGIN") {
//       button.addEventListener("click", function(e) {
//         e.preventDefault();
//         let url = window.location.origin + "/account/login?return_url=/pages/rewards";
//         window.location.href = url;
//       });
//     }

//     // Mark as attached to avoid duplicate listeners
//     button.dataset.redirectAttached = "true";
//   });
// }

// // Start checking for buttons
// attachYotpoButtonRedirect();

// // --- Attach Yotpo button redirects ---
// function attachYotpoButtonRedirect() {
//   const buttons = document.querySelectorAll(".yotpo-widgets-action-button");

//   if (!buttons || buttons.length === 0) {
//     setTimeout(attachYotpoButtonRedirect, 200);
//     return;
//   }

//   buttons.forEach((button) => {
//     if (button.dataset.redirectAttached) return;

//     const label = button.querySelector(".yotpo-button-label")?.textContent.trim().toUpperCase();

//     if (["START YOUR JOURNEY", "REGISTER", "LOGIN"].includes(label)) {
//       button.addEventListener("click", function(e) {
//         e.preventDefault();
//         // Store info in localStorage to indicate redirect is needed
//         localStorage.setItem("yotpoRedirect", JSON.stringify({
//           label: label,
//           returnUrl: "/pages/rewards",
//           active: true
//         }));

//         // Redirect to correct Shopify page
//         if (label === "START YOUR JOURNEY" || label === "REGISTER") {
//           window.location.href = `${window.location.origin}/account/register`;
//         } else if (label === "LOGIN") {
//           window.location.href = `${window.location.origin}/account/login`;
//         }
//       });
//     }

//     button.dataset.redirectAttached = "true";
//   });
// }

// // --- Handle redirect on login/register page ---
// function handleYotpoRedirect() {
//   const yotpoData = JSON.parse(localStorage.getItem("yotpoRedirect") || "{}");
//   if (!yotpoData.active || !yotpoData.returnUrl) return;

//   const registerForm = document.querySelector("#create_customer");
//   const loginForm = document.querySelector("#customer_login");
//   const form = registerForm || loginForm;

//   if (!form) return;

//   // Inject hidden return_url input so Shopify redirects correctly
//   let returnInput = form.querySelector('input[name="return_url"]');
//   if (!returnInput) {
//     returnInput = document.createElement("input");
//     returnInput.type = "hidden";
//     returnInput.name = "return_url";
//     form.appendChild(returnInput);
//   }
//   returnInput.value = yotpoData.returnUrl;

//   // Clean up flag so it only applies once
//   localStorage.removeItem("yotpoRedirect");
// }

// // --- Initialize ---
// document.addEventListener("DOMContentLoaded", function() {
//   attachYotpoButtonRedirect();
//   handleYotpoRedirect();
// });

// --- Attach Yotpo button redirects ---
function attachYotpoButtonRedirect() {
  const buttons = document.querySelectorAll(".yotpo-widgets-action-button");

  if (!buttons || buttons.length === 0) {
    setTimeout(attachYotpoButtonRedirect, 200);
    return;
  }

  buttons.forEach((button) => {
    if (button.dataset.redirectAttached) return;

    const label = button.querySelector(".yotpo-button-label")?.textContent.trim().toUpperCase();

    if (["START YOUR JOURNEY", "REGISTER", "LOGIN"].includes(label)) {
      button.addEventListener("click", function(e) {
        e.preventDefault();
        localStorage.setItem("yotpoRedirect", JSON.stringify({
          label: label,
          returnUrl: "/pages/rewards",
          active: true
        }));

        if (label === "START YOUR JOURNEY" || label === "REGISTER") {
          window.location.href = `${window.location.origin}/account/register`;
        } else if (label === "LOGIN") {
          window.location.href = `${window.location.origin}/account/login`;
        }
      });
    }

    button.dataset.redirectAttached = "true";
  });
}


function handleYotpoRedirect() {
  const yotpoData = JSON.parse(localStorage.getItem("yotpoRedirect") || "{}");
  if (!yotpoData.active || !yotpoData.returnUrl) return;


  const loginForm = document.querySelector("#customer_login");
  if (loginForm) {
    let returnInput = loginForm.querySelector('input[name="return_url"]');
    if (!returnInput) {
      returnInput = document.createElement("input");
      returnInput.type = "hidden";
      returnInput.name = "return_url";
      loginForm.appendChild(returnInput);
    }
    returnInput.value = yotpoData.returnUrl;
    localStorage.removeItem("yotpoRedirect");
  }


  const registerForm = document.querySelector("#create_customer");
  if (registerForm) {

    const observer = new MutationObserver(() => {

      if (document.querySelector("#customer_logout")) {
        localStorage.removeItem("yotpoRedirect");
        window.location.href = yotpoData.returnUrl;
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }


  if (!registerForm && document.querySelector("#customer_logout")) {
    localStorage.removeItem("yotpoRedirect");
    window.location.href = yotpoData.returnUrl;
  }
}


document.addEventListener("DOMContentLoaded", function() {
  attachYotpoButtonRedirect();
  handleYotpoRedirect();
  setTimeout(handleYotpoRedirect, 500);
});

(function(){
  const targetSelector = '._appEmbed_3eyaa_1';
  const styleContent = '._gridItem_1q1d2_172._imageLoading_1q1d2_241{display:none!important} ._formContainer_1q1d2_30{margin:0!important;width:100% !important;max-width:100% !important;box-sizing:border-box;padding:26px 24px 22px!important;background:#fff !important;border-radius:4px !important;} h2._textHeading_2aowh_35{text-transform: uppercase!important;font-weight: 500!important;color: var(--color-sea)!important;text-align: left!important;margin-bottom: 25px!important;font-family: var(--font-primary)!important; font-size:14px!important;} label._formInputFieldLabel_1mxsl_38{font-family: var(--font-primary)!important;font-size: 12px!important;} ._formFieldset_cit2d_82 div:empty{display:none!important} button._formSubmitButton_cit2d_96{font-family: var(--font-primary)!important;font-weight:500!important; font-size: 12px!important;text-transform: uppercase!important;padding: 15px 23px!important;}@media(max-width:767px){._container_3eyaa_70{grid-template-columns:1fr!important;}._formContainer_1q1d2_30{padding:26px 16px 14px!important}}';

  function injectIntoShadow(shadowRoot){
    if(!shadowRoot) return;
    try{
      if(shadowRoot._pwFormStyleInjected) return;
      if(shadowRoot.querySelector(targetSelector)){
        const s = document.createElement('style');
        s.setAttribute('data-pw','form-width');
        s.textContent = styleContent;
        shadowRoot.appendChild(s);
        shadowRoot._pwFormStyleInjected = true;
      }
    }catch(e){/* silent */}
  }

  function scanForShadows(){
    try{
      document.querySelectorAll('*').forEach(el=>{
        try{
          if(el.shadowRoot) injectIntoShadow(el.shadowRoot);
        }catch(e){}
      });
    }catch(e){}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanForShadows);
  } else {
    scanForShadows();
  }

  const mo = new MutationObserver(muts=>{
    muts.forEach(m=>{
      m.addedNodes.forEach(node=>{
        if(node && node.nodeType === 1){
          try{
            if(node.shadowRoot) injectIntoShadow(node.shadowRoot);
            node.querySelectorAll && node.querySelectorAll('*').forEach(child=>{
              if(child.shadowRoot) injectIntoShadow(child.shadowRoot);
            });
          }catch(e){}
        }
      });
    });
  });
  mo.observe(document.documentElement || document.body, {childList:true, subtree:true});
})();